<template>
	<transition name="slideout">
		<div v-if="open" class="slideout">
			<div class="slideout-backdrop" @click="$emit('close')" />
			<Component
				:is="panelTag"
				:class="
					panelClass ||
						'absolute top-0 right-0 flex h-full w-full flex-col overflow-hidden bg-white p-0 shadow-lg slideout-panel sm:w-[450px]'
				"
			>
				<slot />
			</Component>
		</div>
	</transition>
</template>

<script>
let bodyScrollLockCount = 0
let previousBodyOverflow = ''
let previousBodyPaddingRight = ''

export default {
	name: 'NotificationSlideoutShell',
	props: {
		open: {
			type: Boolean,
			default: false
		},
		panelClass: {
			type: [String, Array, Object],
			default: null
		},
		panelTag: {
			type: String,
			default: 'aside'
		}
	},
	data() {
		return {
			bodyScrollLocked: false,
			keydownListenerAttached: false
		}
	},
	mounted() {
		if (this.open) {
			this.lockBodyScroll()
			this.attachKeydownListener()
		}
	},
	watch: {
		open(isOpen) {
			if (isOpen) {
				this.lockBodyScroll()
				this.attachKeydownListener()
				return
			}

			this.unlockBodyScroll()
			this.detachKeydownListener()
		}
	},
	methods: {
		handleKeydown(event) {
			if (event.key === 'Escape' || event.key === 'Esc') {
				this.$emit('close')
			}
		},
		attachKeydownListener() {
			if (process.server || this.keydownListenerAttached) {
				return
			}

			document.addEventListener('keydown', this.handleKeydown)
			this.keydownListenerAttached = true
		},
		detachKeydownListener() {
			if (process.server || !this.keydownListenerAttached) {
				return
			}

			document.removeEventListener('keydown', this.handleKeydown)
			this.keydownListenerAttached = false
		},
		lockBodyScroll() {
			if (process.server || this.bodyScrollLocked) {
				return
			}

			const body = document.body
			const documentElement = document.documentElement

			if (bodyScrollLockCount === 0) {
				previousBodyOverflow = body.style.overflow
				previousBodyPaddingRight = body.style.paddingRight

				const scrollbarWidth =
					window.innerWidth - documentElement.clientWidth

				body.style.overflow = 'hidden'

				if (scrollbarWidth > 0) {
					body.style.paddingRight = `${scrollbarWidth}px`
				}
			}

			bodyScrollLockCount += 1
			this.bodyScrollLocked = true
		},
		unlockBodyScroll() {
			if (process.server || !this.bodyScrollLocked) {
				return
			}

			bodyScrollLockCount = Math.max(0, bodyScrollLockCount - 1)

			if (bodyScrollLockCount === 0) {
				document.body.style.overflow = previousBodyOverflow

				if (previousBodyPaddingRight) {
					document.body.style.paddingRight = previousBodyPaddingRight
				} else {
					document.body.style.removeProperty('padding-right')
				}
			}

			this.bodyScrollLocked = false
		}
	},
	beforeDestroy() {
		this.unlockBodyScroll()
		this.detachKeydownListener()
	}
}
</script>
